import { toast } from "react-toastify";
import { fetchServiceRequestStatsReport } from "../../services/client";
import { startLoading, stopLoading } from "./loader";
import { act } from "react";
import { TYPES } from "../../common/constants";
export const fetchServiceRequestStats = (data) => (dispatch) => {
  dispatch(startLoading());
  return fetchServiceRequestStatsReport(data)
  .then((response) => {
    dispatch(stopLoading());
    if (response.ok || response.status === 200) {
      response.json().then(({data}) => {
        if(!data.serviceRequests || data.serviceRequests.length === 0 || !data.summary) {
          toast.error(" 🚫 No data found for the selected filters.", {
            autoClose: 5000,
            position: "top-center",
          });
          return;
        }

        dispatch({
          type: TYPES.FETCH_SERVICE_REQUEST_STATS_DONE,
          payload: {
            serviceRequests: data.serviceRequests ?? [],
            summary: data.summary ?? {
              total: 0,
              active: 0,
              closed: 0,
              closedPercentage: 0,
              averageDaysToResolution: 0,
            }
          },
        });
      });
    }
  })
  .catch(() => {
    dispatch(stopLoading());
    toast.error(" 🚫 Something went wrong, please try again.", {
      autoClose: 5000,
      position: "top-center",
    });
  });
};

export const clearServiceRequestStats = () => {
  return {
    type: TYPES.CLEAR_SERVICE_REQUEST_STATS_DONE,
  };
}
